import axios from "axios";
import { API } from "../utilities/api.config";

function savePortfolioMetadata(portfolioId, householdId, data) {
  const request = () =>
    axios.patch(
      portfolioId
        ? `${API.SAVE_PORTFOLIO_META}/${portfolioId}`
        : `${API.DEFAULT_PORTFOLIO}/${householdId}/portfolioMeta`,
      data,
      { headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` } }
    );
  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_SAVE_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_SAVE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_SAVE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function clearCurrentPortfolio() {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_CURRENT_PORTFOLIO",
    });
  };
}

function getPortfolio(portfolioId, householdId) {
  const request = () =>
    axios.get(
      portfolioId
        ? `${API.GET_PORTFOLIO}/${portfolioId}`
        : `${API.DEFAULT_PORTFOLIO}/${householdId}/portfolio`,
      { headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` } }
    );
  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_FETCH_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_FETCH_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_FETCH_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function getPortfolioPDF(
  portfolioIds,
  householdId,
  includeModelConstituentDisclosure
) {
  const portfolioIdString = portfolioIds.map(id => `portfolioId=${id || ''}`).join('&');
  const request = () =>
    axios.get(
      `${API.GET_PORTFOLIO_PDF}?householdId=${householdId}&${portfolioIdString}&includeModelConstituentDisclosure=${includeModelConstituentDisclosure}`,
      {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
        responseType: "arraybuffer",
      }
    );

  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_PDF_REQUESTED",
    });

    return request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_PDF_SUCCESS",
          payload: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_PDF_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function sendPortfolioPDF(portfolioId, householdId, email) {
  const request = () =>
    axios.post(
      `${API.POST_PORTFOLIO_PDF}?householdId=${householdId}&portfolioId=${
        portfolioId || ""
      }`,
      { email },
      { headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` } }
    );

  return (dispatch) => {
    dispatch({
      type: "SEND_PORTFOLIO_PDF_REQUESTED",
    });

    return request()
      .then((response) => {
        dispatch({
          type: "SEND_PORTFOLIO_PDF_SUCCESS",
          payload: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: "SEND_PORTFOLIO_PDF_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function archivePortfolio(portfolioId) {
  return (dispatch) => {
    dispatch({
      type: "ARCHIVE_PORTFOLIO_REQUESTED",
    });

    axios
      .patch(
        `${API.PORTFOLIO}/${portfolioId}/archive`,
        {},
        {
          headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
        }
      )
      .then((response) => {
        dispatch({
          type: "ARCHIVE_PORTFOLIO_SUCCESS",
          payload: { ...response, portfolioId: portfolioId },
        });
      })
      .catch((error) => {
        dispatch({
          type: "ARCHIVE_PORTFOLIO_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function getPortfolioScenarioTotals() {
  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_SCENARIO_TOTALS_REQUESTED",
    });

    axios
      .get(API.GET_PORTFOLIO_SCENARIO_TOTALS, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_SCENARIO_TOTALS_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_SCENARIO_TOTALS_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function createPortfolio(householdId, name, initialInvestment) {
  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_CREATE_REQUESTED",
    });
    axios
      .post(
        `${API.CREATE_PORTFOLIO}/${householdId}/portfolio`,
        { name, initialInvestment },
        {
          headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
        }
      )
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_CREATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_CREATE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function saveSortedPortfolioOrders(payload) {
  return (dispatch) => {
    dispatch({
      type: "SAVE_SORTED_PORTFOLIO_ORDERS",
      payload,
    });
  };
}

function savePortfolioName(portfolioId, householdId, data) {
  const request = () =>
    axios.patch(
      portfolioId
        ? `${API.UPDATE_PORTFOLIO_NAME}/${portfolioId}`
        : `${API.DEFAULT_PORTFOLIO}/${householdId}/portfolioName`,
      data,
      { headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` } }
    );
  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_NAME_UPDATE_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_NAME_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_NAME_UPDATE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function onboardMultiplePortfolios(data) {
  const request = () =>
    axios.post(`${API.MULTI_ONBOARD}`, data);
  return (dispatch) => {
    dispatch({ type: "MULTI_PORTFOLIO_ONBOARD_REQUESTED" });
    request()
      .then((response) => {
        dispatch({
          type: "MULTI_PORTFOLIO_ONBOARD_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "MULTI_PORTFOLIO_ONBOARD_FAIL",
          payload: error,
        });
      });
  };
}

function onboardStrategyChange(data) {
  const request = () =>
    axios.post(`${API.STRATEGY_CHANGE_ONBOARD}`, data, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });
  return (dispatch) => {
    dispatch({ type: "STRATEGY_CHANGE_ONBOARD_REQUESTED" });
    request()
      .then((response) => {
        dispatch({
          type: "STRATEGY_CHANGE_ONBOARD_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "STRATEGY_CHANGE_ONBOARD_FAIL",
          payload: error,
        });
      });
  };
}

function getQuikFilledForms(portfolioId) {
  const request = () =>
    axios.get(`${API.PORTFOLIO}/${portfolioId}/resumeOnboard`, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });
  return (dispatch) => {
    dispatch({ type: "PORTFOLIO_GET_QUIK_FILLED_FORMS_REQUESTED" });
    request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_GET_QUIK_FILLED_FORMS_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_GET_QUIK_FILLED_FORMS_FAIL",
          payload: error,
        });
      });
  };
}

function resetQuikFormData() {
  return { type: "PORTFOLIO_QUIK_FORM_DATA_RESET" };
}

function setAccountNumber(portfolioId, accountNumber) {
  const url = `${API.UPDATE_PORTFOLIO_STATUS}/${portfolioId}/setAccountNumber`;

  const payload = {
    accountNumber,
  };

  const request = () =>
    axios.patch(url, payload, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });

  return (dispatch) => {
    dispatch({
      type: "SET_PORTFOLIO_ACCOUNT_NUMBER_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "SET_PORTFOLIO_ACCOUNT_NUMBER_SUCCESS",
          payload: { ...response, portfolioId: portfolioId },
        });
      })
      .catch((error) => {
        dispatch({
          type: "SET_PORTFOLIO_ACCOUNT_NUMBER_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function changeStrategy(portfolioId) {
  const url = `${API.PORTFOLIO}/${portfolioId}/strategyChange`;
  const request = () =>
    axios.patch(
      url,
      {},
      {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      }
    );

  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_STRATEGY_CHANGE_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_STRATEGY_CHANGE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_STRATEGY_CHANGE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function getPortfolioHistory(portfolioId) {
  const url = `${API.GET_PORTFOLIO_HISTORY}/${portfolioId}`;
  const request = () =>
    axios.get(url, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });

  return (dispatch) => {
    dispatch({
      type: "PORTFOLIO_FETCH_HISTORY_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "PORTFOLIO_FETCH_HISTORY_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PORTFOLIO_FETCH_HISTORY_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

export const portfolioAction = {
  archivePortfolio,
  clearCurrentPortfolio,
  createPortfolio,
  getPortfolio,
  getPortfolioHistory,
  getPortfolioPDF,
  getPortfolioScenarioTotals,
  getQuikFilledForms,
  onboardMultiplePortfolios,
  resetQuikFormData,
  savePortfolioMetadata,
  savePortfolioName,
  saveSortedPortfolioOrders,
  sendPortfolioPDF,
  setAccountNumber,
  changeStrategy,
  onboardStrategyChange,
};

export default portfolioAction;



// WEBPACK FOOTER //
// ./src/actions/portfolio.action.js